import { Navigate } from "react-router-dom";
import { useBlogPost } from "../hooks/useBlogPost";
import { BlogRequestState } from "../components/BlogRequestState";

export default function LegacyBlogPage({ slug }) {
  const { post, loading, error, retry } = useBlogPost(slug);
  if (!post) return <BlogRequestState loading={loading} error={error} retry={retry} />;
  // Only redirect when this exact article exists. Never substitute another guide.
  return <Navigate to={`/blog/${post.slug}`} replace />;
}